import React, { useEffect, useState } from "react";
import { WhatsappLogo, X } from "@phosphor-icons/react";
import { openWhatsapp, WA_PHONE_DISPLAY } from "../lib/whatsapp";

export default function WhatsAppFab() {
  const [showHint, setShowHint] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (dismissed) return;
    const first = setTimeout(() => setShowHint(true), 4000);
    return () => clearTimeout(first);
  }, [dismissed]);

  useEffect(() => {
    if (dismissed) return;
    if (!showHint) return;
    const hide = setTimeout(() => setShowHint(false), 9000);
    return () => clearTimeout(hide);
  }, [showHint, dismissed]);

  const onClick = (e) => {
    e.preventDefault();
    openWhatsapp();
  };

  return (
    <div className="fixed bottom-5 left-5 z-50 flex items-end gap-3" data-testid="whatsapp-fab-wrap">
      {/* Hint bubble */}
      {showHint && !dismissed && (
        <div
          data-testid="whatsapp-fab-hint"
          className="hidden sm:flex items-start gap-2 bg-[#F4F3ED] border border-[#0A0A0A] px-4 py-3 max-w-[260px] shadow-[6px_6px_0_#0A0A0A] anim-fade-up"
        >
          <div className="flex-1">
            <div className="font-mono-acc text-[10px] tracking-[0.25em] uppercase text-[#D9381E] mb-1">
              Need help?
            </div>
            <p className="font-body text-sm leading-snug text-[#0A0A0A]">
              Chat with us on WhatsApp — usually replies under 10 mins during market hours.
            </p>
            <div className="font-mono-acc text-[10px] tracking-[0.2em] text-[#4A4A4A] mt-1.5">
              {WA_PHONE_DISPLAY}
            </div>
          </div>
          <button
            onClick={() => {
              setShowHint(false);
              setDismissed(true);
            }}
            aria-label="Dismiss"
            className="text-[#4A4A4A] hover:text-[#D9381E]"
            data-testid="whatsapp-fab-dismiss"
          >
            <X size={14} weight="bold" />
          </button>
        </div>
      )}

      <button
        onClick={onClick}
        data-testid="whatsapp-fab"
        aria-label={`WhatsApp ${WA_PHONE_DISPLAY}`}
        className="relative inline-flex items-center gap-3 bg-[#25D366] text-[#0A0A0A] pl-4 pr-5 py-3.5 chat-dock-shadow border border-[#1ebd5b] hover:bg-[#1ebd5b] transition-colors group cursor-pointer"
      >
        <span className="absolute -top-1 -right-1 w-3 h-3 bg-[#D9381E] rounded-full ring-2 ring-[#F4F3ED] blink" />
        <WhatsappLogo size={22} weight="fill" />
        <span className="font-body text-sm uppercase tracking-[0.18em] font-bold hidden sm:inline">
          WhatsApp Us
        </span>
      </button>
    </div>
  );
}

